'use client';

import styled from 'styled-components';

import { device, typography } from '@/styles/helpers';

export const ScAboutUsModal = styled.div`
  position: relative;
  max-width: 640px;
  background-color: ${({ theme }) => theme.whiteColor};
  margin: 64px auto;
  border-radius: 24px;
  overflow: hidden;

  @media (${device.mobileS}) {
    margin: 16px 8px;
    max-width: 100%;
  }

  & > .content {
    ${typography['body1regular']};
    color: ${({ theme }) => theme.blackColor};
    text-align: center;
    padding: 32px;
    display: flex;
    flex-direction: column;
    row-gap: 24px;

    @media (${device.mobileS}) {
      padding: 32px 16px;
      margin: 8px auto;
    }

    & > .head {
      display: flex;
      flex-direction: column;
      row-gap: 32px;

      & > .title {
        ${typography['headline1']};
        text-transform: uppercase;

        @media (${device.mobileS}) {
          ${typography['headline1mobile']};
        }
      }
    }

    & > .advantages {
      display: flex;
      flex-direction: column;
      row-gap: 12px;
    }
  }

  & > .characters {
    width: 100%;
    height: auto;
  }
`;

export const ScAdvantage = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
  row-gap: 8px;
  background-color: ${({ theme }) => theme.gray1Color};
  width: 100%;
  padding: 24px;
  border-radius: 12px;

  & > .title {
    ${typography['headline3']};
    text-transform: uppercase;
  }
`;
